import React, { ChangeEvent, useState } from 'react';
import { Components } from './styled';
import { ReactComponent as IconShow } from '../../../assets/icons/icon-eye-open.svg';
import { ReactComponent as IconHide } from '../../../assets/icons/icon-eye-closed.svg';
import { ProjectTextFieldType } from './types';

const ProjectTextField = ({
  value,
  onChangeText,
  name,
  errorMessage,
  inputType = 'text',
  placeholder,
  prefixIcon,
  secureTextEntry,
  disabled,
  cursor,
  submitOnEnter,
  ...rest
}: {
  value: string | undefined;
  onChangeText?: (event: ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  errorMessage?: string;
  inputType?: ProjectTextFieldType;
  placeholder: string;
  prefixIcon?: React.ReactNode;
  secureTextEntry?: boolean;
  disabled?: boolean;
  cursor?: string;
  submitOnEnter?: () => Promise<void>;
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const toggleVisiblePassword = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const _onKeyDown = (event?: React.KeyboardEvent<HTMLInputElement>) => {
    if (event?.key === 'Enter') {
      submitOnEnter?.();
    }
  };

  return (
    <Components.Container>
      <Components.TextFieldContainer>
        <Components.TextField
          value={typeof value !== undefined ? value : ''}
          onChange={onChangeText}
          {...(name && { name })}
          placeholder={placeholder || 'Please type...'}
          type={secureTextEntry && !isPasswordVisible ? 'password' : inputType}
          disabled={disabled}
          cursor={cursor}
          {...(submitOnEnter && { onKeyDown: _onKeyDown })}
          {...rest}
        />
        {secureTextEntry && (
          <Components.SecureIconWrapper onClick={toggleVisiblePassword} isPressable>
            {isPasswordVisible ? <IconHide /> : <IconShow />}
          </Components.SecureIconWrapper>
        )}
      </Components.TextFieldContainer>
      {errorMessage && <Components.ErrorMessage>{errorMessage}</Components.ErrorMessage>}
    </Components.Container>
  );
};

export default ProjectTextField;
